import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api';

/**
 * Higher-order component that protects Safari Zone routes
 * Redirects to Entrance if user doesn't have valid Safari Zone access
 */
const withSafariZoneProtection = (Component) => {
  const ProtectedRoute = (props) => {
    const [loading, setLoading] = useState(true);
    const [hasAccess, setHasAccess] = useState(false);
    
    useEffect(() => {
      const checkSafariAccess = async () => {
        try {
          const response = await api.get('/v1/safari-zone/status', { withCredentials: true });
          
          if (response.data && response.data.has_access) {
            setHasAccess(true);
          }
        } catch (error) {
          console.error('Error checking Safari Zone access:', error);
        } finally {
          setLoading(false);
        }
      };
      
      checkSafariAccess();
    }, []);
    
    // Show loading state while checking access
    if (loading) {
      return (
        <div className="safari-zone-loading">
          <div className="loading-spinner"></div>
          <div className="loading-text">Checking Safari Zone access...</div>
          <style jsx="true">{`
            .safari-zone-loading {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              background-color: rgba(0, 0, 0, 0.7);
              z-index: 9999;
            }
            
            .loading-spinner {
              width: 50px;
              height: 50px;
              border: 5px solid #8bc34a;
              border-top-color: transparent;
              border-radius: 50%;
              animation: spin 1s linear infinite;
              margin-bottom: 20px;
            }
            
            .loading-text {
              color: white;
              font-size: 18px;
              font-weight: bold;
              text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
            }
            
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      );
    }
    
    // Redirect to Entrance if no access
    if (!hasAccess) {
      return <Navigate to="/map/SafariZone" replace />;
    }
    
    // Render the protected component if user has access
    return <Component {...props} />;
  };
  
  return ProtectedRoute;
};

export default withSafariZoneProtection;
